import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../../utils/env';
import { IContactData } from './contactData.types';

const contactDataUrl = `${EnvWindow.REACT_APP_SUPPORT_API_URL}/ContactData`;

export async function getContactData(): Promise<AxiosResponse<IContactData>> {
  return await axios.get(contactDataUrl);
}

export async function updateContactData(newDescription: string | null, newContactInfo: string | null): Promise<AxiosResponse> {
  return await axios.put(contactDataUrl, {
    description: newDescription,
    contactInfo: newContactInfo,
  });
}
